import { getHashByIndex } from "../utils/common.utils";
import { selectedElementAll } from "../utils/element-handlers.utils";
import $ from 'jquery';

function TopTabsComponent(
    topTabsElement: HTMLElement,
    routeHash: string | null
) {
    const $topTabsElement = $(topTabsElement);
    const $topTabElements = $topTabsElement.find('.n-top-tab');
    const $topTabsFnfoItemElements = $topTabsElement.find('.n-top-tabs-info-item');
    const $topTabsContentElements = $topTabsElement.find('.n-top-tab-contents .n-top-tab-content');
    const $pristineDesktopElement = $topTabsElement.find('.n-top-tab-item-pristine-desktop');

    $topTabElements.on('click', function ($event) {
        $event.preventDefault();
        activateTopTab($(this).index(), true);
    });

    $pristineDesktopElement.on('click', function ($event) {
        $event.stopPropagation();
    });

    if (routeHash) {
        $topTabElements.each(function () {
            const $topTabElement = $(this);
            const topTabHash = $topTabElement.attr('data-hash-first');

            if (topTabHash && (topTabHash === routeHash)) {
                activateTopTab($topTabElement.index(), false);
            }
        });
    }

    function activateTopTab(index: number, setHash: boolean) {
        const $topTabElement = $($topTabElements.get(index) as HTMLElement);
        const $topTabsFnfoItemElement = $($topTabsFnfoItemElements.get(index) as HTMLElement);
        var $topTabsContentElement = $($topTabsContentElements.get(index) as HTMLElement);

        $topTabsElement.removeClass('n-pristine');

        $topTabElements.removeClass('n-active');
        $topTabElement.addClass('n-active');

        $topTabsFnfoItemElements.removeClass('n-active');
        $topTabsFnfoItemElement.addClass('n-active');

        $topTabsContentElements.removeClass('n-active');
        $topTabsContentElement.addClass('n-active');

        if (setHash) {
            const topTabHash = $topTabElement.attr('data-hash-first');

            if (topTabHash) {
                window.location.hash = topTabHash;
            }
        }

        if (window.innerWidth < 992) {
            setTimeout(function () {
                $('html, body').scrollTop(
                    $topTabElement.offset()!.top - 16
                );
            }, 400);
        }
    }
}

export default function initTopTabsComponent() {
    const urlFirstHash = getHashByIndex(window.location.hash, 0);

    selectedElementAll('div.n-top-tabs', topTabsElement => {
        TopTabsComponent(topTabsElement, urlFirstHash);
    });
}
